/* 路由鉴权 */
import router from './router';

// 路由守卫
router.beforeEach((to, from, next) => {
  // 页面标签名称
  document.title = to.meta.title ? to.meta.title : '四川省中小企业评估测试';
  next();
})